





































import { CollectionItemType } from '@/resource/collection-item/collection-item.model';
import { FetchQuestionsParams } from '@/resource/question/questions.store';
import { InputData, OnSubmitReturn } from '@/utils/form/form-input-typing';
import replaceFormInputValue from '@/utils/form/replace-form-input-value';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import ArrowLink from '../common/ArrowLink.vue';
import FilterDropdown from '../common/filter/FilterDropdown.vue';
import Form from '../common/Form.vue';
import Toggle, { ToggleOption } from '../common/Toggle.vue';

@Component({
  components: { Form, ArrowLink, FilterDropdown, Toggle },
})
export default class QuestionBankFilter extends Vue {
  @Prop({ required: true })
  questionsFilter: FetchQuestionsParams;

  @Prop({ required: true })
  isSubjective: boolean;

  @Prop({ required: true })
  fetchQuestions: (
    isResetPagination: boolean,
  ) => Promise<OnSubmitReturn | null>;

  @Inject('addOrEditQuestion')
  addOrEditQuestion!: (isSubjective: boolean) => Promise<void>;

  @Prop({ required: true })
  changeIsSubjective: (isSubjective: boolean) => Promise<void>;

  inputs: InputData[] = [
    {
      name: 'subject',
      value: {
        selectedSubject: null,
        selectedForm: null,
        selectedChapter: null,
        selectedChapters: [],
      },
      type: 'dropdown-subject',
      isRequired: true,
      dropdownWidth: '200%',
    },
    {
      name: 'keyword',
      value: '',
      placeholder: 'Keywords',
      type: 'text',
      icon: 'ic_search',
      maxWidth: '30%',
    },
  ];

  toggleOptions: ToggleOption[] = [
    {
      value: CollectionItemType.Objective,
      name: 'Objective',
      isSelected: true,
    },
    {
      value: CollectionItemType.Subjective,
      name: 'Subjective',
      isSelected: false,
    },
  ];

  created() {
    replaceFormInputValue(this.inputs, 'subject', {
      selectedSubject: this.questionsFilter.subjectUuid,
      selectedForm: null,
      selectedChapter: null,
      selectedChapters: [],
    });

    this.toggleOptions.forEach(toggleOption => {
      if (toggleOption.value === CollectionItemType.Objective) {
        toggleOption.isSelected = !this.isSubjective;
      } else if (toggleOption.value === CollectionItemType.Subjective) {
        toggleOption.isSelected = this.isSubjective;
      }
    });
  }

  async onSubmitForm(bodyRequest: any): Promise<OnSubmitReturn | null> {
    if (bodyRequest.subject) {
      const subject = bodyRequest.subject;
      this.questionsFilter.subjectUuid = subject.selectedSubject;
      this.questionsFilter.chapterIds = subject.selectedChapters;
      this.questionsFilter.level = subject.selectedForm;
    }

    this.questionsFilter.keyword = bodyRequest.keyword;
    return await this.fetchQuestions(true);
  }

  async onToggleChange(selectedValue: CollectionItemType) {
    let isSubjective = false;

    if (selectedValue === CollectionItemType.Subjective) {
      isSubjective = true;
    }

    return await this.changeIsSubjective(isSubjective);
  }

  trackEvent() {
    this.$sendMpEvent({ event: this.$mp_value.PaperAddOwnQuestionClick });
  }
}
